import { TabView, TabPanel } from 'primereact/tabview';
import ChartView from './Chart';
import { Card } from 'primereact/card';
import CategoryView from './Category';
import GroupView from './Group';
import SetupOptView from './SetupOpt';
import PackageView from './Package';
import StripesView from './Stripes';
import LetPriceCodeView from './LetPriceCode';
import MinGroupView from './MinGroup';
import DrawingsView from './Image';
import FabricView from './Fabric';
import CustomLtrSetupView from './CustomLtr';
import { roleBasedMenuAccess } from '../../authConfig';
import { usePermissions } from '../../PermissionsContext';

export default function Costing() {
    const { roles } = usePermissions();

    const getVisibleTabs = () => {
        if (roles.includes("Admin")) {
            return [
                "Category",
                "Group",
                "Setup Options",
                "Charts",
                "Packages",
                "Stripes",
                "Letter Pricing",
                "Min Qty Groups",
                "Drawings",
                "Fabric",
                "Custom Lettering Templates"
            ];
        }

        const visibleTabs: string[] = [];

        roles.forEach((role) => {
            const rolePermissions = roleBasedMenuAccess[role];
            if (rolePermissions && rolePermissions.tabs["Table Maintenance"]) {
                visibleTabs.push(...rolePermissions.tabs["Table Maintenance"]);
            }
        });

        return Array.from(new Set(visibleTabs));
    };


    const visibleTabs = getVisibleTabs();

    return (
        <div className="grid-nogutter">
            <div className="col-12">
                <Card className="layout-main-card border-noround">
                    <TabView>
                        {visibleTabs.includes("Category") && (
                            <TabPanel header="Category">
                                <CategoryView />
                            </TabPanel>
                        )}
                        {visibleTabs.includes("Group") && (
                            <TabPanel header="Group">
                                <GroupView />
                            </TabPanel>
                        )}
                        {visibleTabs.includes("Setup Options") && (
                            <TabPanel header="Setup Options">
                                <SetupOptView />
                            </TabPanel>
                        )}
                        {visibleTabs.includes("Charts") && (
                            <TabPanel header="Charts">
                                <ChartView />
                            </TabPanel>
                        )}
                        {visibleTabs.includes("Packages") && (
                            <TabPanel header="Packages">
                                <PackageView />
                            </TabPanel>
                        )}
                        {visibleTabs.includes("Stripes") && (
                            <TabPanel header="Stripes">
                                <StripesView />
                            </TabPanel>
                        )}
                        {visibleTabs.includes("Letter Pricing") && (
                            <TabPanel header="Letter Pricing">
                                <LetPriceCodeView />
                            </TabPanel>
                        )}
                        {visibleTabs.includes("Min Qty Groups") && (
                            <TabPanel header="Min Qty Groups">
                                <MinGroupView />
                            </TabPanel>
                        )}
                        {visibleTabs.includes("Drawings") && (
                            <TabPanel header="Drawings">
                                <DrawingsView />
                            </TabPanel>
                        )}
                        {visibleTabs.includes("Fabric") && (
                            <TabPanel header="Fabric">
                                <FabricView />
                            </TabPanel>
                        )}
                        {visibleTabs.includes("Custom Lettering Templates") && (
                            <TabPanel header="Custom Lettering Templates">
                                <CustomLtrSetupView />
                            </TabPanel>
                        )}
                    </TabView>
                </Card>
            </div>
        </div>
    )
}